import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import computerNetworkingImage from '../../images/cardpageimages/technicalcourse/networking.jpg';
import IntroVideos from "../../componants/introvideos";
import ComputerNetworkingModule from "../../componants/allCourseModule/TechnicalCourseModule/ComputerNetworkingModule";

function ComputerNetworking() {
  return (
    <>
      <Header />
      <BannerForAll
        title="COMPUTER NETWORKING FULL COURSE"
        text="Our Computer Networking Full Course covers the fundamentals of computer networks, including network topologies, protocols, IP addressing, routing, and network security. This course provides a strong foundation for those seeking to understand how data is transmitted across the internet and how networks are built and maintained. Perfect for anyone interested in network administration, IT infrastructure, and cybersecurity."
        imageone={computerNetworkingImage}
        imagetwo={computerNetworkingImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="COMPUTER NETWORKING"
      />
      <ComputerNetworkingModule />
      <Footer />
    </>
  );
}

export default ComputerNetworking;
